import axios from ".";
/** Fetch a user's objectives. */
export const getEmployeeObjectives = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/employees/objectives?employeeId=${employeeId}`,
  });
};
/** Fetch a user's key results. */
export const getEmployeeKeyResults = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/employees/keyresults?employeeId=${employeeId}`,
  });
};
/** Fetch a user's initiatives. */
export const getEmployeeInitiatives = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/employees/initiatives?employeeId=${employeeId}`,
  });
};
/** Fetch a user's milestones. */
export const getEmployeeMilestones = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/employees/milestones?employeeId=${employeeId}`,
  });
};
/** Fetch milestone departments for a user. */
export const getEmployeeMilestoneDepartments = (employeeId: any) => {
  return axios({
    method: "GET",
    url: `/milestone/departments/active?employeeId=${employeeId}`,
  });
};
